<template>
  <blocked-content-wrapper :blocked="blocked" class="home-container mb-5">
    <static-block-component page="event" position="top"/>
    <div v-if="event && event.participants ">
      <div v-if="loading">
        <loader-component/>
      </div>
      <div v-else class="player_wrapper">
        <div class="container" v-if="!event.is_geo_blocked">
          <time-flip v-if="event.stream_status === $options.STREAM_STATUS.upcoming"
                     @timeEnded="onTime"
                     :timestamp="event.event_utc_ts"
                     :countDownPreview="countDownPreview"
          />
          <template v-else>
            <player-controller
                v-if="!embedded"
                :options="videoOptions"
                :analytics-options="analyticsOptions"
                :event="event"
                :sport="sportName"
                :teams="teams"
            />
            <div v-else v-html="embedded"></div>
            <button-component
                @btn-click="toggleChat"
                class="chat-toggle-btn"
                v-if="chatIsEnabled"
            >
              {{ $t(`${chatDisplayed ? 'Hide' : 'Show'} chat`) }}
            </button-component>
          </template>
        </div>
        <template v-if="chatIsEnabled">
          <div v-show="chatDisplayed" class="chat">
            <chat-component :event="event"/>
          </div>
        </template>
      </div>
    </div>
    <static-block-component page="event" position="bottom"/>
    <div
        v-if="showEmbeddedPreview"
        class="embeddeb-preview"
        @click.stop.prevent="togglePreview(false)"
    >
      <div class="content">
        <button-component
            variant="icon"
            class="closeIcon"
            @btn-click="togglePreview(false)"
        >
          <XMarkIcon/>
        </button-component>
        <embedded-player
            :link="embeddedPreview"
            :autoplay="true"
            class="preview-player"
        />
      </div>
    </div>
  </blocked-content-wrapper>
</template>

<script>
import WatchScreen from '@/league/views/WatchScreen';

export default {
  name: 'WatchEmbedScreen',
  extends: WatchScreen,
};
</script>

<style lang="scss" scoped src="../../assets/css/watchPage.scss"/>
<style lang="scss" src="../../assets/css/playerPreview.scss"/>

